import { render, staticRenderFns } from "./ed-breadcrumbs.vue?vue&type=template&id=3529b5d8&scoped=true&"
import script from "./ed-breadcrumbs.ts?vue&type=script&lang=ts&"
export * from "./ed-breadcrumbs.ts?vue&type=script&lang=ts&"
import style0 from "./ed-breadcrumbs.scss?vue&type=style&index=0&id=3529b5d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3529b5d8",
  null
  
)

export default component.exports